import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Default workspace tab when URL has no segment.
 * Clients land on Setup; testers on Test cases; staff on Work.
 */
export default function WorkspaceIndexRedirect() {
  const { user } = useSelector((state) => state.auth);
  const isClient = user?.role === 'client' || user?.role === 'client_team';
  const isTester = user?.role === 'tester';
  return <Navigate to={isClient ? 'setup' : isTester ? 'test-cases' : 'work'} replace />;
}
